import { app, pages } from "@microsoft/teams-js";
import { useEffect } from "react";

export function TeamsAppConfig() {
  useEffect(() => {
    app
      .initialize()
      .then(() => {
        console.log("MS Teams Init");

        app.notifySuccess();
        pages.config.setValidityState(true);

        pages.config.registerOnSaveHandler((saveEvent) => {
          pages.config
            .setConfig({
              entityId: "visioRdvMeetingAgent",
              contentUrl: `${window.location.origin}/teams/sidepanel`,
              suggestedDisplayName: "Visio Accueil - Agent",
            })
            .then(() => saveEvent.notifySuccess())
            .catch((error) => {
              console.log("Failed", error);
              saveEvent.notifyFailure(error?.message ?? "setConfig failed");
            });
        });
      })
      .catch((error) => console.error("Failed to initialize Teams SDK", error));
  }, []);
  return <div>Votre compte est maintenant configuré pour être utilisé</div>;
}
